import { AbstractFlow3bixaw6q3bbim as AbstractFlow } from './Flow.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ChannelFlowvdfy82kdxy2m as ChannelFlow } from './internal/ChannelFlow.mjs';
import { EmptyCoroutineContext_instancegbhtm9svfl3r as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { BufferOverflow_SUSPEND_getInstanceob833ibjouyy as BufferOverflow_SUSPEND_getInstance } from '../channels/BufferOverflow.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function flow(block) {
  return new (SafeFlow())(block);
}
function asFlow(_this__u8e3s4) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (asFlow$$inlined$unsafeFlow$1())(_this__u8e3s4);
}
var SafeFlowClass;
function SafeFlow() {
  if (SafeFlowClass === VOID) {
    class $ extends AbstractFlow() {
      constructor(block) {
        super();
        this.w1c_1 = block;
      }
      *x1c(collector, $completion) {
        yield* this.w1c_1(collector, $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SafeFlow', VOID, VOID, VOID, [1]);
    SafeFlowClass = $;
  }
  return SafeFlowClass;
}
function channelFlow(block) {
  return new (ChannelFlowBuilder())(block);
}
function flowOf(value) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (flowOf$$inlined$unsafeFlow$1())(value);
}
function callbackFlow(block) {
  return new (CallbackFlowBuilder())(block);
}
var ChannelFlowBuilderClass;
function ChannelFlowBuilder() {
  if (ChannelFlowBuilderClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(block, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -2 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(context, capacity, onBufferOverflow);
        this.c1d_1 = block;
      }
      d1d(context, capacity, onBufferOverflow) {
        return new (ChannelFlowBuilder())(this.c1d_1, context, capacity, onBufferOverflow);
      }
      *e1d(scope, $completion) {
        return yield* this.c1d_1(scope, $completion);
      }
      toString() {
        return 'block[' + toString(this.c1d_1) + '] -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowBuilder', VOID, VOID, VOID, [1]);
    ChannelFlowBuilderClass = $;
  }
  return ChannelFlowBuilderClass;
}
var CallbackFlowBuilderClass;
function CallbackFlowBuilder() {
  if (CallbackFlowBuilderClass === VOID) {
    class $ extends ChannelFlowBuilder() {
      constructor(block, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -2 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(block, context, capacity, onBufferOverflow);
        this.s1d_1 = block;
      }
      *e1d(scope, $completion) {
        yield* protoOf(ChannelFlowBuilder()).e1d.call(this, scope, $completion);
        if (!scope.u1a()) {
          throw IllegalStateException().o("'awaitClose { yourCallbackOrListener.cancel() }' should be used in the end of callbackFlow block.\nOtherwise, a callback/listener may leak in case of external cancellation.\nSee callbackFlow API documentation for the details.");
        }
        return Unit_instance;
      }
      d1d(context, capacity, onBufferOverflow) {
        return new (CallbackFlowBuilder())(this.s1d_1, context, capacity, onBufferOverflow);
      }
    }
    initMetadataForClass($, 'CallbackFlowBuilder', VOID, VOID, VOID, [1]);
    CallbackFlowBuilderClass = $;
  }
  return CallbackFlowBuilderClass;
}
var asFlow$$inlined$unsafeFlow$1Class;
function asFlow$$inlined$unsafeFlow$1() {
  if (asFlow$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_asFlow) {
        this.t1d_1 = $this_asFlow;
      }
      *u1d(collector, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.t1d_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          yield* collector.v1d(element, $completion);
        }
        return Unit_instance;
      }
      y1c(collector, $completion) {
        return this.u1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    asFlow$$inlined$unsafeFlow$1Class = $;
  }
  return asFlow$$inlined$unsafeFlow$1Class;
}
var flowOf$$inlined$unsafeFlow$1Class;
function flowOf$$inlined$unsafeFlow$1() {
  if (flowOf$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($value) {
        this.w1d_1 = $value;
      }
      *u1d(collector, $completion) {
        yield* collector.v1d(this.w1d_1, $completion);
        return Unit_instance;
      }
      y1c(collector, $completion) {
        return this.u1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    flowOf$$inlined$unsafeFlow$1Class = $;
  }
  return flowOf$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  asFlow as asFlow3ngsnn5xpz8pw,
  callbackFlow as callbackFlow1g384rkuy0hni,
  channelFlow as channelFlow1or0c85tk04v1,
  flowOf as flowOf16f7h10nre075,
  flow as flow3tazazxj2t7g4,
};
//endregion

//# sourceMappingURL=Builders.mjs.map
